// import { useSelector } from 'react-redux';

// export const useAuth = () => {
//     const auth = useSelector((state: any) => state.auth.authState.authUser);
//     return auth;
// };

import { useSelector } from 'react-redux';

export const useAuth = () => {
    const authUser1 = useSelector((state: any) => state.auth.authState.authUser);
    // const authUser2 = useSelector((state: any) => state.dcddAuth.dcddAuthState.dcddAuthUser);
    return authUser1 ;
    // return authUser1 || authUser2;
};
